/**
 * Kinng.app — AI Agent API.
 */
import api from "./api";

export const aiAgentApi = {
    // Settings
    getSettings: () => api.get("/tenant/ai-agent/settings"),
    patchSettings: (body) => api.patch("/tenant/ai-agent/settings", body),
    stats: () => api.get("/tenant/ai-agent/stats"),
    test: (body) => api.post("/tenant/ai-agent/test", body),
    // Knowledge base
    listKnowledge: () => api.get("/tenant/ai-agent/knowledge"),
    createKnowledge: (body) => api.post("/tenant/ai-agent/knowledge", body),
    updateKnowledge: (id, body) => api.patch(`/tenant/ai-agent/knowledge/${id}`, body),
    deleteKnowledge: (id) => api.del(`/tenant/ai-agent/knowledge/${id}`),
    reorderKnowledge: (ids_in_order) => api.patch("/tenant/ai-agent/knowledge/reorder", { ids_in_order }),
    // Internal users
    listInternal: () => api.get("/tenant/internal-users"),
    createInternal: (body) => api.post("/tenant/internal-users", body),
    updateInternal: (id, body) => api.patch(`/tenant/internal-users/${id}`, body),
    toggleInternal: (id) => api.patch(`/tenant/internal-users/${id}/toggle`, {}),
    deleteInternal: (id) => api.del(`/tenant/internal-users/${id}`),
};

export default aiAgentApi;
